import { createSlice } from '@reduxjs/toolkit';

import client from '../prismic';

// Slice
const categorySlice = createSlice({
  name: 'category',
  initialState: {
    loading: true,
    error: null,
    data: null,
  },
  reducers: {
    setCategoryLoadingAction: (state, action) => {
      state.loading = action.payload;
    },
    setCategoryErrorAction: (state, action) => {
      state.error = action.payload;
    },
    setCategoryDataAction: (state, action) => {
      state.data = action.payload;
    },
  },
});

const {
  setCategoryDataAction,
  setCategoryErrorAction,
  setCategoryLoadingAction,
} = categorySlice.actions;

// Thunk
export const fetchCategories = () => (dispatch, getState) => {
  if (getState().category.data) return;

  client
    .getAllByType('category')
    .then((data) => dispatch(setCategoryDataAction(data)))
    .catch((err) => dispatch(setCategoryErrorAction(err)))
    .finally(() => dispatch(setCategoryLoadingAction(false)));
};

// Exports
export default categorySlice.reducer;
export {
  setCategoryDataAction,
  setCategoryErrorAction,
  setCategoryLoadingAction,
};

